// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const palossand: PokeData = {
  "id": 770,
  "name": "palossand",
  "height": 13,
  "weight": 2500,
  "base_experience": 168,
  "types": [
    PokeType.GHOST,
    PokeType.GROUND
  ],
  "api_moves": [
    "sand-attack",
    "absorb",
    "mega-drain",
    "hypnosis",
    "harden",
    "sandstorm",
    "giga-drain",
    "shadow-ball",
    "astonish",
    "sand-tomb",
    "iron-defense",
    "earth-power",
    "bulldoze",
    "shore-up"
  ],
  "moves": [
    "sandstorm",
    "shadow-ball",
    "earth-power",
    "soul-sacrifice",
    "poltergeist",
    "confuse-ray",
    "mud-shot",
    "magnitude",
    "bone-throw",
    "spectral-chain",
    "earthquake",
    "fissure",
    "mud-slap"
  ],
  "evolution_chain": {
    "id": 397,
    "item": null,
    "species": [
      {
        "name": "sandygast",
        "order": 769,
        "types": [
          PokeType.GHOST,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "palossand",
        "order": 770,
        "types": [
          PokeType.GHOST,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 769,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 159,
    "speed": 63,
    "ability_power": 179
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
